/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useEffect, useState } from 'react'

export default function TableBody({
    item, 
    index, 
    tableIndex,
    setState,
    state,
    setToastErrorMessage,
    oldState,
    errorIndex, 
    setErrorIndex,
    itemErrorIndex, 
    setItemErrorIndex,
    setAppliedError,
    mainReceivedAmount
}) {
    const [inputEnteredValue, setInputEnteredValue] = useState(state.invoices[tableIndex].items[index].received_line_amount.toFixed(2))
    useEffect(() => {    
        setErrorIndex(null)
        setItemErrorIndex(null);
        setToastErrorMessage("")
        setInputEnteredValue(state.invoices[tableIndex].items[index].received_line_amount.toFixed(2))
    }, [mainReceivedAmount])

    const clearIfValueIsZero = (index, name) => (e) => {
        if (Number(e.target.value) === 0) {
            setInputEnteredValue('')
        }
    };

    const setZeroIfEmpty = (index, name) => (e) => {
        let value = e.target.value;
        if (value.trim() === '') {
            value = '0.00';
        } else {
            value = parseFloat(value).toFixed(2);
        }
        setInputEnteredValue(value);
    };

    /**
     * The function `handleValue` updates the state of invoices and calculates the total applied amount
     * and remaining amount based on an input value.
     */
    const handleValue = (value) => {
        setAppliedError(false)
        let inputValue = parseFloat(value)
        let totalAppliedAmount = 0;
        const updatedInvoices = state.invoices.map((invoice, idx = 0) => {
            let dueAmount = 0;
            let invoiceLineTotal = 0 
            return {
                ...invoice,
                items: invoice.items.map((item, item_index = 0) => {
                    const balanceAmount = parseFloat(oldState.invoices[idx].items[item_index].balance_line_amount);
                    dueAmount += (index === item_index && tableIndex === idx) ? (balanceAmount - inputValue): parseFloat(state.invoices[idx].items[item_index].balance_line_amount);
                    const amountToApply = inputValue;
                    totalAppliedAmount +=  (index === item_index && tableIndex === idx) ? parseFloat(inputValue) : parseFloat(state.invoices[idx].items[item_index].received_line_amount || 0);
                    invoiceLineTotal += (index === item_index && tableIndex === idx) ? parseFloat(inputValue) : ( tableIndex === idx ? (parseFloat(state.invoices[idx].items[item_index].received_line_amount || 0)) : 0);
                    if((index === item_index && tableIndex === idx)){
                        return {
                            ...item,
                            received_line_amount: amountToApply,
                            balance_line_amount: parseFloat((balanceAmount - amountToApply)),
                        };
                    } else {
                        return item
                    }
               
                }),
                due_amount: tableIndex === idx ? parseFloat(dueAmount) : state.invoices[idx].due_amount,
                received_amount: parseFloat(tableIndex === idx ? invoiceLineTotal : state.invoices[idx].received_amount || 0),
            };

        });
        setState((prevState) => ({
            ...prevState,
            invoices: updatedInvoices,
            applied_amount: parseFloat(totalAppliedAmount),
            remaining_amount: parseFloat(state.remaining_amount) > 0 ? parseFloat((state.remaining_amount - totalAppliedAmount)): 0,
        }));
    }
    /**
     * The function `handleItemInput` updates the `received_line_amount` property of an item in the
     * `state.invoices` array based on user input.
     */
    const handleItemInput = (e) => {   
        e.preventDefault();    
        setErrorIndex(null)
        setItemErrorIndex(null);
        setToastErrorMessage("")
        if (e.target.value > oldState.invoices[tableIndex].items[index]["balance_line_amount"]) {
            setErrorIndex(tableIndex)
            setItemErrorIndex(index)
            setToastErrorMessage(`${state?.invoices[tableIndex]?.invoice_number} ${state?.invoices[tableIndex]?.invoice_name}: Item balance cannot be negative`);
            if(e.target.value?.length <= 13) {
                const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                if(regex.test(e.target.value)) {
                    setInputEnteredValue(e.target.value)
                    handleValue(parseFloat(e.target.value))
                }
            }
            if(e.target.value === "") {
                setInputEnteredValue("");
                handleValue(0)
            }
        } else {
            if(e.target.value?.length <= 13) {
                const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                if(regex.test(e.target.value)) {
                    setInputEnteredValue(e.target.value)
                    handleValue(parseFloat(e.target.value))
                }
            }
            if(e.target.value === "") {
                setInputEnteredValue("");
                handleValue(0)
            }
        }
    };
    
    return (
        <tr>
            <td className='px-[21px] py-3 flex justify-start'>
                {` ${oldState.invoices[tableIndex].invoice_type === "fee" ? `${item.line_item}` : `${item.item_name} [${item.line_item}]`}`} 
            </td>
            <td className='py-1.5 px-[21px]'>
                <span className='flex justify-end'>
                    {item?.total_line_amount?.toFixed(2)}
                </span>
            </td>
            <td className='py-1.5 flex justify-end mx-auto px-[21px]'>
                <input 
                    type="text"  
                    autoComplete='off'
                    value={inputEnteredValue} 
                    // onWheel={ event => event.currentTarget.blur() }
                    // onFocus={()=>setErrorIndex(null)}
                    onChange={handleItemInput}
                    id={index+"_received_amount"}
                    onFocus={clearIfValueIsZero(index,'index+"_received_amount"')}
                    onBlur={setZeroIfEmpty(index,'index+"_received_amount"')}
                    // onKeyDown={handleKeyDownForNumber}
                    className={`border border-[#${(errorIndex === tableIndex && itemErrorIndex === index )? "F04438" : "D0D5DD"}] w-[120px] p-1.5 rounded text-end outline-none`}/>
            </td>
            <td className='py-1.5 px-[21px]'>
                <span className='flex justify-end'>
                    {item?.balance_line_amount?.toFixed(2)}
                </span>
            </td>
        </tr>
    )
}
